import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, Effect } from '@ngrx/effects';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/exhaustMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { of } from 'rxjs/observable/of';

import { AuthService } from '../../shared/services/auth.service';
import * as Forgot from '../actions/forgot-password';
import { ForgotPasswordForm } from '../models/forgot-password';

@Injectable()
export class ForgotPasswordEffects {
  /*
   * Redirection page de confirmation
  */
  @Effect({dispatch: true})
  forgotPasswordRedirect = this.actions$
    .ofType(Forgot.FORGOT_PASSWORD_REDIRECT)
    .exhaustMap(auth => {
      return fromPromise(this.router.navigate(['/auth/password/wait']))
        .map(_ => new Forgot.ForgotPasswordRedirectSuccess())
        .catch(error => of(new Forgot.ForgotPasswordRedirectFailure(false)));
    });
  /*
   * Demande de mot de passe réussie
  */
  @Effect({dispatch: true})
  forgotPasswordSuccess = this.actions$
    .ofType(Forgot.FORGOT_PASSWORD_SUCCESS)
    .map((action: Forgot.ForgotPasswordSuccess) => action.payload)
    .map(a => {
      return new Forgot.ForgotPasswordRedirect();
    });
  /*
   * Demande de courriel
  */
  @Effect()
  requestEmailLink$ = this.actions$
    .ofType(Forgot.FORGOT_PASSWORD_SEND_EMAIL_LINK)
    .map((action: Forgot.ForgotPasswordSendEmailLink) => action.payload)
    .exhaustMap(auth => {
        return this.authService.sendPasswordResetEmail(auth)
          .map((user: any) => {
            return new Forgot.ForgotPasswordSendEmailLinkSuccess();
          })
          .catch(error => of(new Forgot.ForgotPasswordSendEmailLinkFailure(error)));
      },
    );
  @Effect({dispatch: false})
  resetPassordSuccess$ = this.actions$
    .ofType(Forgot.RESET_PASSWORD_SUCCESS)
    .do(() => {
      this.router.navigate(['/auth/password/confirm']);
    });
  /*
   * Demande de mot de passe
  */
  @Effect()
  resetPassword$ = this.actions$
    .ofType(Forgot.FORGOT_PASSWORD)
    .map((action: Forgot.ForgotPassword) => action.payload)
    .exhaustMap((auth: ForgotPasswordForm) => {
        return this.authService.forgotPassword(auth)
          .map((user: any) => {
            return new Forgot.ForgotPasswordSuccess();
          })
          .catch(error => of(new Forgot.ResetPasswordFailure(error)));
      },
    );
  /*
  .exhaustMap(auth => {
    return Observable.fromPromise(this.router.navigate(['/auth/password']))
      .map(a => {
        return new Forgot.ForgotPasswordRedirectSuccess();
      })
      .catch(error => of(new Forgot.ForgotPasswordRedirectFailure(error)));
  });
*/
  @Effect()
  resetPasswordUpdatePassword$ = this.actions$
    .ofType(Forgot.RESET_PASSWORD)
    .map((action: Forgot.ResetPassword) => action.payload)
    .exhaustMap(auth => {
        return this.authService.resetPassword(auth)
          .map((user: any) => {
            return new Forgot.ResetPasswordSuccess();
          })
          .catch(error => of(new Forgot.ResetPasswordFailure(error)));
      },
    );
  @Effect({dispatch: false})
  resetPasswordUpdatePasswordRedirect = this.actions$
    .ofType(Forgot.RESET_PASSWORD_UPDATE_PASSWORD_REDIRECT)
    .do(() => {
      this.router.navigate(['/auth/login/email']);
    });

  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private router: Router,
  ) {
  }
}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/forgot-password/effects/forgot-password.ts